import { reactive } from "vue";
import { TabsType } from "./status-tabs.interface";
export const projectPaths = [];
export const projectStatusArr = reactive<TabsType[]>([
  {
    type: "dlx",
    name: "待立项",
  },
  {
    type: "dtb",
    name: "已立项",
  },
  {
    type: "tbz",
    name: "投标中",
  },
  {
    type: "ylb",
    name: "已落标",
  },
  {
    type: "yzb",
    name: "已中标",
  },
  {
    type: "dsg",
    name: "待施工",
  },
  {
    type: "sgz",
    name: "施工中",
  },
  {
    type: "yjg",
    name: "已竣工",
  },
  {
    type: "ygb",
    name: "已关闭",
  },
  {
    type: undefined,
    name: "全部",
  },
]);
export const flowStatusArr = reactive<TabsType[]>([
  {
    type: "dtj",
    name: "待提交",
  },
  {
    type: "spz",
    name: "审批中",
  },
  {
    type: "sptg",
    name: "审批通过",
  },
  {
    type: "spbtg",
    name: "审批不通过",
  },
  {
    type: "ycx",
    name: "已撤销",
  },
  {
    type: "yzf",
    name: "已作废",
  },

  {
    type: undefined,
    name: "全部",
  },
]);

export const contractStatusArr = reactive<TabsType[]>([
  {
    type: "wsx",
    name: "未生效",
  },
  {
    type: "lyz",
    name: "履约中",
  },
  {
    type: "shz",
    name: "变更中",
  },
  {
    type: "lywb",
    name: "履约完毕",
  },
  {
    type: "yzf",
    name: "已作废",
  },

  {
    type: undefined,
    name: "全部",
  },
]);
export const warhouseStatusArr = reactive<TabsType[]>([
  {
    type: "wrk",
    name: "未入库",
  },
  {
    type: "bfrk",
    name: "部分入库",
  },
  {
    type: "rkwb",
    name: "入库完毕",
  },
  {
    type: "bkrk",
    name: "不可入库",
  },
  {
    type: undefined,
    name: "全部",
  },
]);
export const WarrantyStatusArr = reactive<TabsType[]>([
  {
    type: "warn",
    name: "预警中",
  },
  {
    type: "overdue",
    name: "已过期",
  },
  {
    type: undefined,
    name: "全部",
  },
]);
